import { render } from "./CampaignsBulkList.vue?vue&type=template&id=8102a472&scoped=true"
import script from "./CampaignsBulkList.vue?vue&type=script&lang=ts"
export * from "./CampaignsBulkList.vue?vue&type=script&lang=ts"

import "./CampaignsBulkList.vue?vue&type=style&index=0&id=8102a472&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-8102a472"

export default script